import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingStrikethrough: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 16v-5h11.973q.027.246.027.5A4.5 4.5 0 0 1 9.5 16zm14-6.5v-3H8v-2h6V0H6.5a4.5 4.5 0 0 0-4.032 6.5H0v3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingStrikethrough
